import { useQuery } from '@tanstack/react-query';

import { transportationApi } from '~endpoints/Transportation';
import { pointToPointTicketKeys } from '~queryKeys/transportation/pointToPointTicket';

export async function fetchPopularRouteList() {
  return transportationApi.v1.RailEurope.getPopularRouteList();
}

const usePopularRouteList = (options?: Record<string, unknown>) => {
  return useQuery({
    queryKey: pointToPointTicketKeys.getPopularRouteList(),
    queryFn: () => fetchPopularRouteList().then((res) => res.data),
    ...options,
  });
};

export default usePopularRouteList;
